import { Link, useHistory, useLocation } from 'react-router-dom';

import Logo from '../../_content/images/main/logos/innovate_uk_logo.png';
import { clearJwtToken, clearMfaToken } from 'lib/src/utils/jwt';

const Header: React.FC = () => {
    const history = useHistory();
    const { pathname } = useLocation();

    const handleLogout = () => {
        clearJwtToken();
        clearMfaToken();
        history.replace('/auth/login');
    };

    return (
        <header className="header">
            <div className="logo">
                <Link to="/" className="logo">
                    <img alt="company logo" src={Logo} />
                </Link>
            </div>
            {pathname.toLowerCase().includes('auth/mfa') && (
                <button className="logout-button" type="button" onClick={handleLogout}>
                    <span className="text">Logout</span> <i className="far fa-sign-out"></i>
                </button>
            )}
        </header>
    );
};

export default Header;
